import React from 'react'

import { AuthStoreContext } from '../store'

export const useAuthStore = () => React.useContext(AuthStoreContext)
